export enum SupplyBulkActionExportType {
    SupplierProduct = "SUPPLIER_PRODUCT",
    SupplierVariant = "SUPPLIER_VARIANT",
}
